import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { HeightLimitedExpander } from 'cat-ecommerce-alloy';
import { isEmpty, replaceTokensInString } from '../../../../utils';
import { COMPATIBILITY_ID } from '../constants';

const ProductCompatibility = ({ productId }) => {
  const [t] = useTranslation();
  const partNumber = useSelector(
    s => s.products?.byId?.[productId]?.partNumber || ''
  );
  const compatibleModels = useSelector(
    s => s.products.byId?.[productId]?.compatibleModels
  );
  const sectionTitle = partNumber
    ? replaceTokensInString(t('PDP_COMPATIBLE_MODELS'), partNumber)
    : t('COMPATIBLE_MODELS');
  return (
    <section className="py-3" id={COMPATIBILITY_ID}>
      <h2 className="h3 display-3">{sectionTitle}</h2>
      {!isEmpty(compatibleModels) ? (
        <HeightLimitedExpander
          buttonSize="large"
          id="compatibilityExpander"
          lessButtonText={t('VIEW_LESS')}
          moreButtonText={t('VIEW_MORE_PRODUCTS')}
        >
          {Object.entries(compatibleModels).map(([key, value]) => (
            <div className="mt-3" key={key}>
              <h3 className="text-uppercase text-sm fw-bold text-sans-serif">
                {key}
              </h3>
              <h4 className="text-md text-sans-serif font-weight-normal">
                {compatibleModels[key].join(' ')}
              </h4>
            </div>
          ))}
        </HeightLimitedExpander>
      ) : (
        <p>{t('PDP_COMPATIBILITY_UNAVAILABLE')}</p>
      )}
    </section>
  );
};

ProductCompatibility.propTypes = {
  productId: PropTypes.string
};

export default ProductCompatibility;
